import React, {useCallback} from 'react';
import ContextMenu from '../../../../shared/components/context-menus/context_menu';
import {Bounds, ContextMenuItem, Person} from '../TimesheetsCalendarTypes';
import {openCreateTaskModal, openTimeRegModal} from './CalendarEventModalLogic';
import {markEventAsConvertedType} from './useConvertedEventTracking';
import {trackEvent} from '../../../../../tracking/amplitude/TrackingV2';

type EventContextMenuProps = {
	contextMenuItem: ContextMenuItem;
	bounds: Bounds;
	closeContextMenu: () => void;
	person: Person;
	markEventAsConverted: markEventAsConvertedType;
	sideModalOpen: boolean;
};

const EventContextMenu = ({
	contextMenuItem,
	bounds,
	closeContextMenu,
	person,
	markEventAsConverted,
	sideModalOpen,
}: EventContextMenuProps): React.JSX.Element => {
	const onRegisterTime = () => {
		trackEvent('Register Time Menu Item', 'Clicked');
		openTimeRegModal(person, contextMenuItem.calendarEvent, markEventAsConverted, sideModalOpen);
	};

	const onConvertToTask = () => {
		trackEvent('Convert To Task Menu Item', 'Clicked');
		openCreateTaskModal(person, contextMenuItem.calendarEvent, markEventAsConverted);
	};

	const closeContextMenuCallback = useCallback(() => {
		closeContextMenu();
	}, [contextMenuItem]);

	const options = [
		{text: 'Register time', onClick: onRegisterTime},
		{text: 'Convert to task', onClick: onConvertToTask},
	];

	return (
		<ContextMenu
			options={options}
			contextMenuPosition={{x: bounds.x, y: bounds.y}}
			closeContextMenu={() => closeContextMenuCallback()}
			newStyle
		/>
	);
};

export default EventContextMenu;
